import React from 'react';
import ProductPage from '../product_page/productPage';

const OnSale = () => {
    return <ProductPage
        page_title={'Sale'}
        initial_filters={{on_sale: true}}
        seo={{
            title: "Fashion Sale - Up to 50% Off | The Sidewalk",
            description: "Save on the latest fashion from emerging brands. Shop our sale collection with discounts up to 50% off."
        }}
    />;
};

export default OnSale;